export default "__VITE_ASSET__BDeSSWn8__"